import api from '../plugins/axios';
import moment from 'moment';
import { prepareStripeInvoice } from '@/utils/utils';

export default {
  namespaced: true,
  state: {
    payment_method: null,
    customer: {},
    upcoming_invoice: null,
    subscription: null,
    invoices: [],
    invoicesCursor: null,
    receipts: null,
    receiptsMore: null,
    quantity: 0,
  },
  getters: {
    isTrial(state) {
      return state.subscription?.status === 'trialing';
    },
    trialWillEnd(state, getters) {
      return moment().add(getters.trialDaysLeft, 'days').format('ll');
    },
    trialDaysLeft(state, getters, rootState) {
      return rootState.auth.currentWorkspace.trial_days;
    },
    currentBalance(state) {
      return state.customer ? -state.customer.balance : 0;
    },
    currentInterval(state) {
      if (state.subscription == null) return 'month';
      else return state.subscription.interval;
    },
    upcomingInvoice(state) {
      return state.upcoming_invoice ? prepareStripeInvoice(state.upcoming_invoice) : null;
    },
    invoices(state) {
      return state.invoices.map((invoice) => prepareStripeInvoice(invoice));
    },
    onlyTrialPage(state, _, rootState) {
      return !(state.subscription || rootState.auth.currentWorkspace.manual_payments);
    },
  },
  actions: {
    async init({ dispatch, state, commit }) {
      await dispatch('loadBilling');
      if (state.subscription && !state.subscription.cancel_at_period_end) {
        try {
          commit('RESET_INVOICES');
          const invoice = await dispatch('loadUpcomingInvoice');
          commit('SET_UPCOMING_INVOICE', invoice);
        } catch {
          console.log('upcoming invoice error');
        }
        dispatch('loadHistory');
        // dispatch('loadReceipts') // Всё ли нужно сразу?
      }
    },
    async loadBilling({ commit }) {
      const { data } = await api.get('/billing/billing');
      commit('SET_SUBSCRIPTION', data.subscription);
      commit('SET_CUSTOMER', data.customer);
      commit('SET_PAYMENT_METHOD', data.payment_method);
    },
    async updateBilling({ commit }, data) {
      const resp = await api.put('/billing/billing', data);
      commit('SET_CUSTOMER', resp.data);
    },
    // eslint-disable-next-line no-empty-pattern
    async loadUpcomingInvoice({}, plan = '') {
      const params = plan ? `?plan=${plan}` : '';
      const { data } = await api.get(`/billing/invoices/upcoming${params}`);
      return data.invoice;
    },
    async loadSubscription({ commit }) {
      const resp = await api.get('/billing/subscription');
      commit('SET_SUBSCRIPTION', resp.data);
    },
    async loadHistory({ state, commit }) {
      const { data } = await api.get('/billing/invoices', { params: { cursor: state.invoicesCursor } });
      commit('SET_INVOICES', data);
    },
    async loadReceipts({ commit }, starting_after) {
      // const cursor = 1
      const { data } = await api.get('/billing/invoices/receipts', { params: { starting_after } });
      commit('SET_RECEIPTS', { ...data, ...{ starting_after } });
    },
    async loadPaymentMethod({ commit }) {
      // subscription card
      const { data } = await api.get('/billing/payment_method');
      commit('SET_PAYMENT_METHOD', data);
    },
    async updatePaymentMethod() {
      const url = window.location.origin + '/settings/billing/payment_method';
      const { data } = await api.post('/billing/payment_method', { callback: url });
      window.location.assign(data.session_url);
    },
    async switchSubscription({ commit, dispatch }, plan) {
      const resp = await api.put('/billing/subscription', { plan });
      commit('SET_SUBSCRIPTION', resp.data);
      const invoice = await dispatch('loadUpcomingInvoice');
      commit('SET_UPCOMING_INVOICE', invoice);
    },
    async cancelSubscription({ commit }, reason) {
      const { data } = await api.delete('/billing/subscription', { data: { reason: reason } });
      commit('SET_SUBSCRIPTION', data);
      commit('SET_UPCOMING_INVOICE', null);
    },
    async resumeSubscription({ commit, dispatch }) {
      const resp = await api.post('/billing/subscription/resume');
      commit('SET_SUBSCRIPTION', resp.data);
      const invoice = await dispatch('loadUpcomingInvoice');
      commit('SET_UPCOMING_INVOICE', invoice);
    },
    // eslint-disable-next-line no-empty-pattern
    async createSubscription({}, { plan, callback, promo }) {
      // const url = window.location.origin + '/settings/billing';
      const resp = await api.post('/billing/subscription', { callback, plan, promo });
      window.location.assign(resp.data.session_url);
    },
  },
  mutations: {
    SET_INVOICES(state, { invoices, cursor }) {
      state.invoices = state.invoices.concat(invoices);
      state.invoicesCursor = cursor;
    },
    RESET_INVOICES(state) {
      state.invoices = [];
    },
    SET_RECEIPTS(state, { receipts, has_more, starting_after }) {
      if (starting_after) state.receipts = state.receipts.concat(receipts);
      else state.receipts = receipts;
      state.receiptsMore = has_more;
    },
    SET_CUSTOMER(state, customer) {
      state.customer = customer;
    },
    SET_SUBSCRIPTION(state, subscription) {
      state.subscription = subscription;
      if (subscription) {
        state.quantity = subscription.quantity;
      }
    },
    SET_UPCOMING_INVOICE(state, invoice) {
      state.upcoming_invoice = invoice;
    },
    SET_PAYMENT_METHOD(state, card) {
      state.payment_method = card;
    },
  },
};
